import apiClient from '../apiClient';

/**
 * Get all augmentation jobs in review queue
 * @param {string} customerId - Optional customer ID filter
 * @returns {Promise} API response with review queue items
 */
export const getReviewQueue = (customerId = null) => {
  const params = customerId ? new URLSearchParams({ customerId }) : '';
  return apiClient.get(`/augmentation-review${params ? `?${params}` : ''}`);
};

/**
 * Get detailed information for a specific augmentation job in review
 * @param {string} jobId - Augmentation job ID
 * @returns {Promise} API response with job details
 */
export const getReviewJobDetail = (jobId) => {
  return apiClient.get(`/augmentation-review/${jobId}`);
};

/**
 * Resolve an augmentation job with field resolutions
 * @param {string} jobId - Augmentation job ID
 * @param {Object} resolution - Resolution data with field resolutions
 * @returns {Promise} API response
 */
export const resolveAugmentationJob = (jobId, resolution) => {
  return apiClient.post(`/augmentation-review/${jobId}/resolve`, resolution);
};
